import { type SEOHandle } from "@nasa-gcn/remix-seo";
import {
  json,
  type LoaderFunctionArgs,
  type MetaFunction,
} from "@remix-run/node";
import { useSearchParams } from "@remix-run/react";
import { useTranslation } from "react-i18next";
import { LandingBackground } from "#app/components/landing/landing-background";
import { LandingHeader } from "#app/components/landing/landing-header";
import { requireAnonymous } from "#app/utils/auth.server.ts";
import { ProviderConnectionForm } from "#app/utils/connections.tsx";

export const handle: SEOHandle & { i18n: string[] } = {
  i18n: ["auth", "marketing"],
  getSitemapEntries: () => null,
};

export async function loader({ request }: LoaderFunctionArgs) {
  await requireAnonymous(request);
  return json({});
}

export default function LoginPage() {
  const { t } = useTranslation(["auth", "common"]);
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get("redirectTo") || "/u/alpha/agent";

  return (
    <main className="relative min-h-dvh font-(family-name:--font-body)">
      <LandingBackground />
      <LandingHeader showLogin={false} />
      <div className="relative h-[calc(100dvh-100px)] z-10 flex flex-col justify-center">
        <div className="mx-auto w-full max-w-md px-4 text-center">
          <div className="flex flex-col gap-3 text-center mb-5">
            <h1
              className="text-[38px] xl:text-h1 font-bold leading-tight text-[#141A42] dark:text-zinc-100"
              style={{ fontFamily: "var(--font-body), sans-serif" }}
            >
              {t("auth:welcomeBack")}
            </h1>
            <p
              className="text-base font-medium leading-6 text-[#676767]"
              style={{ fontFamily: "var(--font-body), sans-serif" }}
            >
              {t("auth:signInContinue")}
            </p>
          </div>
          <ProviderConnectionForm
            type="Login"
            providerName="oauth2"
            redirectTo={redirectTo}
            buttonText={t("auth:logIn")}
            buttonClassName="flex w-full h-10 items-center justify-center rounded-[10.44px] px-6 py-2.5 text-base font-bold leading-[130%] tracking-[0.03em] capitalize text-[#D7DDF7] transition-opacity hover:opacity-95 focus-visible:ring-2 focus-visible:ring-white/30 bg-[linear-gradient(93.53deg,#141A42_14.58%,#6577A4_110.19%)]"
          />
        </div>
      </div>
    </main>
  );
}

export const meta: MetaFunction = () => [{ title: "Login to Supervity AI" }];
